import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import {
  GET_ALL_GAMESLIST,
  GET_ALL_JACKPOT_GAME_CHART,
  GET_ALL_STARTLINE_GAMES_CHART,
  GET_ALL_STARLINE_PANA_CHART,
  GET_ALL_JACKPOT_JODI_CHART,
} from "../../service/admin.service";

/* ===================== SKELETONS ===================== */

const SkeletonItem = () => (
  <div className="tw-animate-pulse tw-flex tw-justify-between tw-items-center tw-p-3 tw-rounded-xl tw-border">
    <div className="tw-h-4 tw-w-40 tw-bg-gray-200 tw-rounded" />
    <div className="tw-h-8 tw-w-20 tw-bg-gray-200 tw-rounded-xl" />
  </div>
);

const SkeletonMainItem = () => (
  <div className="tw-animate-pulse tw-flex tw-justify-between tw-items-center tw-p-3 tw-rounded-xl tw-border">
    <div className="tw-h-4 tw-w-40 tw-bg-gray-200 tw-rounded" />
    <div className="tw-flex tw-gap-2">
      <div className="tw-h-8 tw-w-20 tw-bg-gray-200 tw-rounded-xl" />
      <div className="tw-h-8 tw-w-20 tw-bg-gray-200 tw-rounded-xl" />
    </div>
  </div>
);

/* ===================== PAGE ===================== */

const Charts = () => {
  const [getChart, setgetChartData] = useState([]);
  const [getStarline, setgetStarlineData] = useState([]);
  const [getJackpot, setgetJackpotData] = useState([]);
  const [getJackpotPana, setgetJackpotPanaData] = useState([]);
  const [getJackpotJodi, setgetJackpotJodiData] = useState([]);

  // separate loading states
  const [loadingMain, setLoadingMain] = useState(true);
  const [loadingStarline, setLoadingStarline] = useState(true);
  const [loadingJackpot, setLoadingJackpot] = useState(true);

  const getResponseData = () => {
    // MAIN
    GET_ALL_GAMESLIST()
      .then((res) => setgetChartData(res?.data?.filter((item) => item.activeStatus === true) || []))
      .catch(console.error)
      .finally(() => setLoadingMain(false));

    // STARLINE
    GET_ALL_STARTLINE_GAMES_CHART()
      .then((res) => setgetStarlineData(res?.data || []))
      .catch(console.error)
      .finally(() => setLoadingStarline(false));

    // JACKPOT
    GET_ALL_JACKPOT_GAME_CHART()
      .then((res) => setgetJackpotData(res?.data || []))
      .catch(console.error)
      .finally(() => setLoadingJackpot(false));

    // background data (no skeleton dependency)
    GET_ALL_STARLINE_PANA_CHART().then((r) =>
      setgetJackpotPanaData(r?.data || []),
    );

    GET_ALL_JACKPOT_JODI_CHART().then((r) =>
      setgetJackpotJodiData(r?.data || []),
    );
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getResponseData();
  }, []);

  return (
    <>
      <Navbar />

      <div className="tw-py-10 tw-px-4 md:tw-px-8 lg:tw-px-12 lg:tw-mt-20 tw-mt-10">
        <div className="tw-max-w-7xl tw-mx-auto">
          {/* MAIN */}
          <div className="tw-mb-6">
            <MainChartSection
              title="Chart"
              data={getChart}
              loading={loadingMain}
            />
          </div>

          {/* STARLINE + JACKPOT */}
          <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-6">
            <ChartSection
              title="Starline Chart"
              subtitle="OPEN - CLOSE"
              data={getStarline}
              linkType="starline"
              showAllOption
              allType="starline"
              allData={getJackpotPana}
              loading={loadingStarline}
            />

            <ChartSection
              title="Jackpot Chart"
              subtitle="OPEN - CLOSE"
              data={getJackpot}
              linkType="jackpot"
              showAllOption
              allType="jackpot"
              allData={getJackpotJodi}
              loading={loadingJackpot}
            />
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

/* ===================== HELPERS ===================== */

const getDetailsLink = (type, name) => {
  const formatted = name?.toLowerCase().replace(/\s+/g, "");

  switch (type) {
    case "jodi":
      return `/jodi-chart/${formatted}/jodi-chart`;
    case "pana":
      return `/pana-chart/${formatted}/pana-chart`;
    case "starline":
      return `/starline/${formatted}`;
    case "jackpot":
      return `/andarbahar/${formatted}`;
    default:
      return "/";
  }
};

/* ===================== CHART SECTION ===================== */

const ChartSection = ({
  title,
  subtitle,
  data,
  linkType,
  showAllOption,
  allData,
  allType,
  loading,
}) => {
  const navigate = useNavigate();

  const handleAllClick = () => {
    const route =
      allType === "starline"
        ? "/starline/allratanstarline"
        : "/andarbahar/allratanjackpot";

    navigate(route, {
      state: { title, type: allType, data: allData },
    });
  };

  return (
    <div className="tw-rounded-2xl tw-p-6 md:tw-p-2 tw-shadow-sm tw-border tw-border-gray-100">
      <div className="tw-mb-4">
        <h2 className="tw-text-lg md:tw-text-xl tw-font-bold">{title}</h2>
        <p className="tw-text-xs tw-text-gray-500">{subtitle}</p>
      </div>

      {showAllOption && (
        <button
          onClick={handleAllClick}
          className="tw-text-[20px] md:tw-text-[25px] tw-font-semibold tw-text-[#015E65] hover:tw-underline tw-py-2"
        >
          ALL {title.toUpperCase()}
        </button>
      )}

      <div className="tw-space-y-3">
        {loading ? (
          Array.from({ length: 6 }).map((_, i) => <SkeletonItem key={i} />)
        ) : data?.length > 0 ? (
          data.map((item, index) => (
            <ChartItem
              key={index}
              name={item.providerName}
              link={getDetailsLink(linkType, item.providerName)}
              state={{ title: item.providerName, id: item._id }}
            />
          ))
        ) : (
          <p className="tw-text-sm tw-text-gray-400">No charts available</p>
        )}
      </div>
    </div>
  );
};

/* ===================== MAIN SECTION ===================== */

const MainChartSection = ({ title, data, loading }) => (
  <div className="tw-rounded-2xl tw-p-6 tw-shadow-sm tw-border tw-border-gray-100">
    <h2 className="tw-text-lg md:tw-text-xl tw-font-bold tw-mb-4">{title}</h2>

    <div className="tw-space-y-3">
      {loading ? (
        Array.from({ length: 6 }).map((_, i) => <SkeletonMainItem key={i} />)
      ) : data?.length > 0 ? (
        data.map((item, index) => (
          <MainChartItem
            key={index}
            name={item.providerName}
            linkPana={getDetailsLink("pana", item.providerName)}
            linkJodi={getDetailsLink("jodi", item.providerName)}
            state={{ title: item.providerName, id: item._id }}
          />
        ))
      ) : (
        <p className="tw-text-sm tw-text-gray-400">No charts available</p>
      )}
    </div>
  </div>
);

/* ===================== ITEMS ===================== */

const ChartItem = ({ name, link, state }) => (
  <div className="tw-flex tw-justify-between tw-items-center tw-p-3 tw-border tw-rounded-xl tw-bg-white hover:tw-shadow-md">
    <h3 className="tw-font-semibold">{name?.toUpperCase()}</h3>

    <Link
      to={link}
      state={state}
      className="tw-inline-flex tw-items-center tw-justify-center tw-bg-black tw-text-white tw-text-sm tw-font-medium tw-px-5 tw-py-2 tw-rounded-xl hover:tw-text-white"
    >
      View
    </Link>
  </div>
);

const MainChartItem = ({ name, linkPana, linkJodi, state }) => (
  <div className="tw-flex tw-justify-between tw-items-center tw-p-3 tw-border tw-rounded-xl tw-bg-white hover:tw-shadow-md">
    <h3 className="tw-font-semibold">{name?.toUpperCase()}</h3>

    <div className="tw-flex tw-gap-2">
      <Link to={linkPana} state={state} className="tw-inline-flex tw-items-center tw-justify-center tw-bg-black tw-text-white tw-text-sm tw-font-medium tw-px-5 tw-py-2 tw-rounded-xl hover:tw-text-white">
        Pana
      </Link>
      <Link to={linkJodi} state={state} className="tw-inline-flex tw-items-center tw-justify-center tw-bg-black tw-text-white tw-text-sm tw-font-medium tw-px-5 tw-py-2 tw-rounded-xl hover:tw-text-white">
        Jodi
      </Link>
    </div>
  </div>
);

export default Charts;
